<div class="main-panel pt-0 pb-4" style="overflow: hidden;">
	<div class="container-fluid">
		<div class="col-sm-12 px-0 align-self-end">
			<div class="row align-items-center">
				<div class="col-sm-10">
					<h3 class="">
						{{ 'OUTPUT_MANAGEMENT.OM_SIDEBAR_OUTPUT_CONFIG' | translate }}
					</h3>
				</div>
				<div class="col-sm-2">
					<button type="button" (click)="addOutputConfig()" class="btn btn-primary btn-sm float-right">
						{{ 'OUTPUT_MANAGEMENT.BTN_ADD_CONFIGURATION' | translate }}
					</button>
				</div>
			</div>
			<hr class="mt-0 mb-3" />
		</div>
		<div class="col-sm-12 px-0 my-2" [ngClass]="{'content-hide': isMinimized, 'content-show': !isMinimized}">
			<ag-grid-angular #agGrid style="width: 100%;" [style.height.px]="divHeight" id="outputconfig" [rowData]="rowData" [modules]="modules" [sideBar]="{ toolPanels: ['columns'] }"
				class="ag-theme-balham" [columnDefs]="columnDefs" [frameworkComponents]="frameworkComponents"
				  [enableRangeSelection]="true" [paginationPageSize]="10" [defaultColDef]="defaultColDef"
				[pagination]="true" (columnResized)="onColumnResized($event)" (gridReady)="onGridReady($event)"
				[suppressMenuHide]="true" [gridOptions]="gridOptions"></ag-grid-angular>
		</div>
	</div>
</div>